import Controller from "./bustype.controller";
import template from "./bustype.html";

const bustype = {
  template,
  controller: Controller,
};

export default bustype;



// WEBPACK FOOTER //
// ./src/pages/bustype/bustype.component.js